import styled, { css } from 'styled-components'
import { media } from '../../../utils/mediaQuery'

export const ViewToggleRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`

export const ViewToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  box-shadow: 0 4px 12px -1px rgba(0, 0, 0, 0.05);
`

export const ViewToggleButton = styled.button.withConfig({
  shouldForwardProp: (prop) =>
    prop !== '$active' && prop !== '$iconOnlyBelowTablet' && prop !== '$iconOnlyBelowMobile',
})<{
  $active: boolean
  $iconOnlyBelowTablet?: boolean
  $iconOnlyBelowMobile?: boolean
}>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  padding: 6px 8px 6px 6px;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ $active }) => ($active ? 'rgba(18, 193, 253, 0.1)' : 'transparent')};
  color: ${({ theme, $active }) => ($active ? '#0294df' : theme.colors.text.primary)};
  cursor: pointer;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme, $active }) =>
    $active ? theme.typography.fontWeight.medium : theme.typography.fontWeight.normal};
  line-height: normal;
  white-space: nowrap;
  transition:
    background ${({ theme }) => theme.transitions.fast},
    color ${({ theme }) => theme.transitions.fast};

  > span {
    transition: opacity ${({ theme }) => theme.transitions.fast};
  }

  &:disabled {
    cursor: not-allowed;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover:not(:disabled) {
      background: ${({ $active, theme }) =>
        $active ? 'rgba(18, 193, 253, 0.18)' : theme.colors.background.tertiary};

      > span {
        opacity: 1;
      }
    }
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.border.focus};
    outline-offset: 2px;
  }

  ${({ $iconOnlyBelowTablet }) =>
    $iconOnlyBelowTablet &&
    css`
      ${media.tabletDown} {
        padding: 6px;
      }
    `}

  ${({ $iconOnlyBelowMobile }) =>
    $iconOnlyBelowMobile &&
    css`
      ${media.mobileOnly} {
        padding: 6px;
      }
    `}
`

export const ViewToggleIcon = styled.span<{ $active?: boolean }>`
  display: flex;
  opacity: ${({ $active }) => ($active ? 1 : 0.5)};

  svg {
    display: block;
    flex-shrink: 0;
  }
`

export const ViewToggleLabel = styled.span.withConfig({
  shouldForwardProp: (prop) =>
    prop !== '$active' && prop !== '$hideBelowTablet' && prop !== '$hideBelowMobile',
})<{
  $active?: boolean
  $hideBelowTablet?: boolean
  $hideBelowMobile?: boolean
}>`
  opacity: ${({ $active }) => ($active ? 1 : 0.5)};

  ${({ $hideBelowTablet }) =>
    $hideBelowTablet &&
    css`
      ${media.tabletDown} {
        display: none;
      }
    `}

  ${({ $hideBelowMobile }) =>
    $hideBelowMobile &&
    css`
      ${media.mobileOnly} {
        display: none;
      }
    `}
`
